import * as React from "react";
import type { SVGProps } from "react";
const SvgBottleAndGlassInFridge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 2h19c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H1c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1m18 2H2v16h17zm2 15.73c.6-.34 1-.99 1-1.73V6c0-.74-.4-1.38-1-1.73zM9 7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2.62c-.65.79-1 1.77-1 2.8v4.59c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4.59c0-1.03-.35-2.01-1-2.8zm-1 9H5v-3.59c0-.64.25-1.25.71-1.71A1 1 0 0 0 6 9.99v-2h1v2c0 .26.11.52.29.71.46.46.71 1.06.71 1.71zm9-10h-6c-.55 0-1 .45-1 1v1.4c0 1.86 1.28 3.41 3 3.86V16h-1c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-1v-3.74c1.72-.45 3-2 3-3.86V7c0-.55-.45-1-1-1m-1 2.4c0 1.1-.9 2-2 2s-2-.9-2-2V8h4z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBottleAndGlassInFridge;
